<template>
  <div ref="footer" id="footer" :class="$mq" class="px-10 flex justify-center font-sans" style="font-size: 0.75rem;">

    <!-- wrapper -->
    <div style="max-width: 1100px;">

      <!-- vaihtoehtoinen pikkulogo -->
      <div v-if="$mq === 'phone'" class="flex flex-center mt-6">
        <img src="@/assets/cb_logo_grey.svg" alt="Ketterä" style="height: 18px;">
        <span class="font-ui-main ml-1" style="font-family: 'Ubuntu Condensed', sans-serif; font-size: 17px; color: #8a8887;">Ketterä</span>
      </div>

      <!-- aiheet / valinnat -->
      <div id="footer-topics" class="relative flex flex-center py-6">
        <!-- pikkulogo -->
        <section v-if="$mq !== 'phone'" class="flex flex-start">
          <img src="@/assets/cb_logo_grey.svg" alt="Ketterä" style="height: 18px;">
          <span class="font-ui-main ml-1" style="font-family: 'Ubuntu Condensed', sans-serif; font-size: 17px; color: #8a8887;">Ketterä</span>
        </section>
        <!-- valitsimet -->
        <!-- <a
          href="https://docs.google.com/document/d/1Pc9bDrogZRJwMv-UUHUGHnQxhgk2QKYG4eIE50oCdxg/edit?usp=sharing"
          target="_blank" rel="noopener noreferrer"
        >Palaute</a> -->
        <div @click="controlModals" class="pointer noselect">Palaute</div>
        <div @click="controlModals('policy')" class="pointer noselect">Käyttöehdot</div>
        <div @click="controlModals('contacts')" class="pointer noselect">Tekijätiedot</div>
        <div @click="controlModals('login')" class="pointer noselect">Hallinnointi</div>
        <!-- <router-link to="/hallinnointi" tag="div" class="pointer noselect">Hallinnointi</router-link> -->
        <!-- <div v-for="(topic, index) in topics" :key="index" class="pointer noselect">{{topic}}</div> -->

      </div>

      <hr>

      <!-- yhteistyökumppaneiden logot -->
      <div @mouseover="logoColors = true" @mouseleave="logoColors = false" id="footer-logos" class="py-4">
        <!-- <div v-for="(partner, index) in partners" :key="index" style="background-color: red; border: 1px solid white;"> -->
        <div v-for="(partner, index) in partners" :key="index" class="flex justify-evenly">
          <a :href="partner.url" target="_blank" rel="noopener noreferrer" class="flex flex-center">
            <img v-if="!logoColors" :src="require('../assets/' + partner.logoGrey)" :alt="partner.name" class="">
            <img v-else :src="require('../assets/' + partner.logo)" :alt="partner.name" class="">
          </a>
        </div>
      </div>

      <hr>

      <!-- paluu sivun ylälaitaan -->
      <div @click="backToTop" class="flex flex-center py-4 pointer noselect">
        <span>Palaa alkuun</span>
        <i class="material-icons font-8 ml-1" style="transform: rotate(-90deg);">play_arrow</i>
      </div>

    </div>

    <!-- modal: yhteystiedot / käyttäjäehdot -->
    <portal to="modals" v-if="showModal">
      <modal-contacts
        v-if="modalType === 'contacts'"
        :show="showModal"
        @close="showModal = false"
      ></modal-contacts>
      <modal-user-policy
        v-else-if="modalType === 'policy'"
        :show="showModal"
        @close="showModal = false"
      ></modal-user-policy>
      <modal-login
        v-else-if="modalType === 'login'"
        :show="showModal"
        @close="showModal = false"
      ></modal-login>
      <modal-feedback
        v-else
        :show="showModal"
        @close="showModal = false"
      ></modal-feedback>
    </portal>
    <!-- modal: käyttäjäehdot -->
    <portal to="modals" v-if="showModal">
    </portal>

  </div>
</template>

<script>
import modalContacts from '@/components/modals/modalContacts'
import modalUserPolicy from '@/components/modals/modalUserPolicy'
import modalFeedback from '@/components/modals/modalFeedback'
import modalLogin from '@/components/modals/modalLogin'

export default {
  components: {
    modalContacts,
    modalUserPolicy,
    modalFeedback,
    modalLogin
  },

  data () {
    return {
      topics: ['palaute', 'käyttöehdot', 'yhteystiedot', 'hallinnointi'],
      partners: [
        { name: 'DAC', url: 'http://www.agilecities.fi/', logo: 'DAC_logo.png', logoGrey: 'DAC_logo_grey.png' },
        { name: 'TUNI', url: 'https://www.tampere3.fi/', logo: 'TUNI_logo.svg', logoGrey: 'TUNI_logo_grey.svg' },
        { name: 'VTT', url: 'https://www.vtt.fi/', logo: 'VTT_logo.svg', logoGrey: 'VTT_logo_grey.svg' },
        { name: 'Syke', url: 'http://www.syke.fi/fi-FI', logo: 'SYKE_logo.svg', logoGrey: 'SYKE_logo_grey.svg' },
        { name: 'STN', url: 'https://www.aka.fi/', logo: 'STN_logo.png', logoGrey: 'STN_logo_grey.png' }
      ],
      logoColors: false,
      showModal: false,
      modalType: ''
    }
  },

  computed: {
    footerHeight () {
      return this.$store.state.ui.footerHeight
    }
  },

  methods: {
    controlModals (data) {
      if (data === 'login') {
        if (this.$store.state.isLogged === true) {
          this.$router.push({ name: 'manage' })
        } else {
          this.modalType = data
          this.showModal = true
        }
      } else if (data) {
        this.modalType = data
        this.showModal = true
      } else {
        this.modalType = ''
        this.showModal = true
      }
    },

    backToTop () {
      document.getElementById('app').scrollTop = 0
      // document.documentElement.scrollTop = 0;
    }
  },

  mounted () {
    let height = this.$refs.footer.offsetHeight
    this.$store.dispatch('trackFooterHeight', height)
  }
  /* updated () {
    let height = this.$refs.footer.offsetHeight
    this.$store.dispatch('trackFooterHeight', height)
  } */
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

#footer {
  background-color: #302e2d;
  color: #8a8887;
  //font-family: ClassicGrotesqueW02, Arial, sans-serif;
  hr {
    border: 0;
    border-top: 1px solid #494848;
  }
  a {
    text-decoration: none;
    color: #8a8887;
  }
}

#footer-topics {
  & div, & section, & a { margin: 0 20px; }
  .phone & {
    //img { display: none; }
    div, section, a { margin: 0 10px; }
  }
}

#footer-logos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  & > div {
    position: relative;
    //min-width: 100px;
    height: 50px;
    margin: 0 20px;
    a {
      flex-grow: 1;
      flex-shrink: 1;
      display: block;
      height: 100%;
      img {
        max-height: 35px;
        height: 100%;
      }
    }
  }
}
</style>
